import { useEffect } from 'react';
import { useBiLogger } from '@wix/da-bi/pkg/hooks/useBiLogger';
import {
  PureBiData,
  StudioEarningsWithdrawalClickBiEvent,
  StudioWithdrawalPaymentMethod,
} from '@wix/da-bi/pkg/events';

export function useOpenStripeModalFromQueryParam(
  openStripeRoot: () => void
): void {
  const logEvent = useBiLogger();

  useEffect(() => {
    const urlParams = new URLSearchParams(window.location.search);
    const modalParam = urlParams.get('modal');

    if (modalParam === 'stripe') {
      logEvent(
        PureBiData<StudioEarningsWithdrawalClickBiEvent>({
          evid: 159,
          payment_method: StudioWithdrawalPaymentMethod.Stripe,
          process_step: 'resume_connection',
        })
      );
      openStripeRoot();
      // Remove 'modal' from the URL
      urlParams.delete('modal');
      const newUrl = urlParams.toString()
        ? `${window.location.pathname}?${urlParams.toString()}`
        : window.location.pathname;
      window.history.replaceState({}, '', newUrl);
    }
  }, [openStripeRoot, logEvent]);
}
